import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentCandidateRowResponse {
  id!: string;

  @observable
  credit!: number;

  @observable
  debit!: number;

  @observable
  documentRowDescription!: string;

  @observable
  rowOrder!: number;

  @observable
  syntheticAccount!: string;

  @observable
  analyticAccount!: string;

  @observable
  paragraph?: string;

  @observable
  article?: string;

  @observable
  papAnalyticBreakdown?: string;

  @observable
  papTransaction?: string;

  @observable
  partnerBalance?: string;
}
